@if (showModal) {
<div class="outage-modal-background" (click)="dismiss()">
  <div class="outage-modal-content" (click)="$event.stopPropagation()">
    <button class="outage-modal-close" aria-label="Close" (click)="dismiss()">
      <i class="fa fa-close"></i>
    </button>
    <h2 class="outage-modal-title">{{ title }}</h2>
    <p class="outage-modal-message">{{ message }}</p>
    <button class="btn btn-primary outage-modal-button" (click)="dismiss()">
      OKAY, GOT IT!
    </button>
  </div>
</div>
}
